import styled from '@emotion/styled';

export const PageTitle = styled.h2`
  text-align: center;

  @media screen and (max-width: 747.98px) {
    font-size: 24px;
    margin-bottom: 24px;
  }

  @media screen and (min-width: 748px) {
    font-size: 48px;
    margin-bottom: 40px;
  }
`;
